/** PDP action bar native ATC proxy (PDPBAR-3, PRD D4). Clicks Horizon's real button; re-syncs on variant:update. */
export const NATIVE_ATC_SELECTOR = 'add-to-cart-component button[ref="addToCartButton"]';
export const VARIANT_UPDATE_EVENT = 'variant:update';
export const NATIVE_PROXY_ID = 'pb-bar-native-atc';

/** @param {{ hasNativeButton: boolean, disabled?: boolean, label?: string }} input */
export function resolveNativeProxyState({ hasNativeButton, disabled = false, label = '' }) {
  if (!hasNativeButton) return { render: false, disabled: true, label: '' };
  const trimmed = String(label || '').replace(/\s+/g, ' ').trim();
  return { render: true, disabled: !!disabled, label: trimmed || 'Add to cart' };
}

export function readNativeButtonLabel(button) {
  if (!button) return '';
  const content = button.querySelector('.add-to-cart-text__content');
  const raw = content ? content.textContent : button.textContent;
  return String(raw || '').replace(/\s+/g, ' ').trim();
}

export function readNativeButtonState(button) {
  if (!button) return { hasNativeButton: false, disabled: true, label: '' };
  return { hasNativeButton: true, disabled: button.disabled, label: readNativeButtonLabel(button) };
}

export function applyNativeProxyState(proxyEl, state) {
  if (!proxyEl) return false;
  if (!state.render) {
    proxyEl.remove();
    return false;
  }
  proxyEl.disabled = state.disabled;
  proxyEl.setAttribute('aria-disabled', state.disabled ? 'true' : 'false');
  proxyEl.dataset.pbNativeState = state.disabled ? 'disabled' : 'enabled';
  const textEl = proxyEl.querySelector('.pb-trigger-text');
  if (textEl) textEl.textContent = state.label;
  return true;
}

export function findNativeAddToCartButton(doc) {
  if (!doc?.querySelector) return null;
  const btn = doc.querySelector(NATIVE_ATC_SELECTOR);
  return btn instanceof HTMLButtonElement ? btn : null;
}

function hideBarIfNoPrimary(proxyEl) {
  const bar = proxyEl?.closest('.pb-action-bar');
  if (!bar) return;
  if (!bar.querySelector('.pb-action-bar__row .builder-trigger-btn, .pb-action-bar__row #pb-bar-native-atc')) {
    bar.remove();
  }
}

function syncFromNative(doc, proxyEl, nativeBtn) {
  const kept = applyNativeProxyState(proxyEl, resolveNativeProxyState(readNativeButtonState(nativeBtn)));
  if (!kept) hideBarIfNoPrimary(proxyEl);
  return kept;
}

export function boot(win) {
  const doc = win.document;
  const proxy = doc.getElementById(NATIVE_PROXY_ID);
  if (!proxy) return;

  let nativeBtn = findNativeAddToCartButton(doc);
  if (!syncFromNative(doc, proxy, nativeBtn)) return;

  proxy.addEventListener('click', () => {
    nativeBtn = findNativeAddToCartButton(doc);
    if (!nativeBtn || proxy.disabled) return;
    nativeBtn.dataset.puppet = 'true';
    nativeBtn.click();
  });

  doc.addEventListener(VARIANT_UPDATE_EVENT, () => {
    nativeBtn = findNativeAddToCartButton(doc);
    syncFromNative(doc, proxy, nativeBtn);
  });

  const resetPuppet = () => {
    nativeBtn = findNativeAddToCartButton(doc);
    if (nativeBtn) nativeBtn.dataset.puppet = 'false';
  };
  doc.addEventListener('cart:update', resetPuppet);
  doc.addEventListener('cart:error', resetPuppet);
}

if (typeof document !== 'undefined' && document.getElementById?.(NATIVE_PROXY_ID)) {
  boot(typeof window !== 'undefined' ? window : globalThis);
}
